export default __webpack_public_path__ + "static/media/11.1af1608b.jpg";